import classnames from 'classnames'
import { memo } from 'react'
import { useSelector } from 'react-redux'
import { RenderProperty } from 'shared/renderProperties'
import { tileEntityAllIdsSelector } from '~/app/store/tileEntity'
import { currentPageSelector, totalEntityCountSelector } from '~/app/store/paging'
import { stringRenderPropertySelector } from '~/app/store/config'
import { FullBleedUploadTile } from '~/app/features/Gallery/components/PreviewArea/FullBleedUploadTile/FullBleedUploadTile'
import { CareTile } from '~/app/features/Gallery/components/PreviewArea/CareTile'
import { shouldHideCareTileSelector, shouldHideFbuTileSelector } from '~/app/store/refinement/selectors'
import { getIsLoadMoreAvailable } from '~/app/store/config/selectors'
import { DesignSkeleton } from '~/app/features/Gallery/components/PreviewArea/DesignSkeleton'
import { currentPageInfoSelector } from '~/app/store/paging/selectors'
import { ErrorBoundary } from '@vp/swan'
import { DesignTilesList } from '~/app/features/Gallery/components/PreviewArea/DesignTilesList'

const PreviewListComponent = () => {
  const resultCount = useSelector(totalEntityCountSelector)
  const tileEntityIds = useSelector(tileEntityAllIdsSelector)
  const stringRenderProperty = useSelector(stringRenderPropertySelector)
  const currentPage = useSelector(currentPageSelector)
  const shouldHideFbuTile = useSelector(shouldHideFbuTileSelector)
  const isLoadMoreAvailable = useSelector(getIsLoadMoreAvailable)
  const { pageSize } = useSelector(currentPageInfoSelector)
  const shouldHideCareTile = useSelector(shouldHideCareTileSelector)

  const tilePreviewSize = stringRenderProperty(RenderProperty.TilePreviewSize)

  const isFirstPage = currentPage === 1
  const isFirstPageAndTemplatesExist = isFirstPage && resultCount > 0
  const shouldShowFbuTile = isFirstPageAndTemplatesExist && !shouldHideFbuTile
  const shouldShowCareTile = isFirstPageAndTemplatesExist && !shouldHideCareTile

  const careTilePosition = pageSize - 1
  const isCareTileAtEnd = careTilePosition >= tileEntityIds.length
  const shouldShowTileCareAtEnd = shouldShowCareTile && isCareTileAtEnd

  return (
    <ul
      className={classnames('preview-area', `preview-area-${tilePreviewSize?.toLowerCase()}`, 'stylized-list', 'stylized-list-minimal')}
      data-testid="preview-list"
    >
      {shouldShowFbuTile && (
        <ErrorBoundary fallback={<>&nbsp;</>} forceShowError={false}>
          <FullBleedUploadTile key="fbu-tile" userInteractionLocation="tile" />
        </ErrorBoundary>
      )}
      <DesignTilesList />
      {shouldShowTileCareAtEnd && <CareTile />}
      {isLoadMoreAvailable && <DesignSkeleton />}
    </ul>
  )
}

export const PreviewList = memo(PreviewListComponent)
